import React from 'react';
import styled from '@emotion/styled'
import ItemCart from './ItemCart';


const WrapContainer = styled.div`
    border: 1px solid #c1c1c1;
    width: 80%;
    margin: 0 auto;

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        border: 1px solid #ddd;
    }

    th, td {
        text-align: left;
        padding: 16px;

        @media(max-width: 678px){
            font-size: 1.5rem;
            padding: 5px;
        }

        @media(max-width: 613px){
            font-size: 1.3rem;
        }

         @media(max-width: 532px){
            font-size: 1.1rem;
            padding: 3px;
        }
    }

    tr:nth-of-type(even) {
        background-color: #f2f2f2;
    }

    @media(max-width: 579px){
            border: 0;
    }

`;


const DivTotales = styled.div`
    width: 300px;
    margin-top: 10px;
    text-align: right;
    float: right;

    table td{
        margin: 0;
        padding: 5px;
        text-align: right;
    }

    h4{
        margin: 0;
        margin-right: 20px;
    }

    span{
        color: gray;
    }

    
    
`;



const ListItems = ({ items, subtotal, taxes, total }) => {

    const internalItem = items.map(line_item => {
        return <ItemCart key={line_item.id.toString()} item={line_item} />
    });

    return (
        <WrapContainer>
            <table>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Name</th>
                        <th>Selected</th>
                        <th>Quantity</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {internalItem}
                </tbody>
            </table>
            <DivTotales>
                <table>
                    <tbody>
                        <tr>
                            <td><strong>Subtotal: </strong> </td>
                            <td><span>$ {subtotal}</span></td>
                        </tr>
                        <tr>
                            <td><strong>Taxes:  </strong></td>
                            <td><span>$ {taxes}</span></td>
                        </tr>
                        <tr>
                            <td><strong>Total: </strong></td>
                            <td><span>$ {total}</span></td>
                        </tr>
                    </tbody>
                </table>
            </DivTotales>

        </WrapContainer>


    );
}

export default ListItems;